export default __webpack_public_path__ + "static/rollingPapers-d9773d17935d8d484c34515dbb4d7db9.png";